export interface IconProps {
  width?: number;
  height?: number;
}

export default function FormatTextIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="12.607"
      viewBox="0 0 22 12.607"
    >
      <g transform="translate(59)">
        <path
          fill="currentColor"
          d="M8.75-2.119H3.291L2.285.665H.561l4.526-12.446h1.885L11.48.665H9.756zm-.467-1.329L6.021-9.77 3.758-3.448zm4.292-.844a5.528 5.528 0 01.611-2.649 4.43 4.43 0 011.679-1.769 4.606 4.606 0 012.38-.629 4.367 4.367 0 012.245.557 3.71 3.71 0 011.419 1.4v-1.8h1.652V.665h-1.652v-1.832A3.85 3.85 0 0119.463.261a4.325 4.325 0 01-2.236.566 4.461 4.461 0 01-2.37-.647 4.535 4.535 0 01-1.67-1.814 5.649 5.649 0 01-.611-2.658zm8.333.018a4 4 0 00-.449-1.94 3.17 3.17 0 00-1.211-1.266 3.3 3.3 0 00-1.679-.44 3.307 3.307 0 00-1.67.431 3.127 3.127 0 00-1.2 1.257 4 4 0 00-.449 1.94 4.094 4.094 0 00.449 1.967A3.176 3.176 0 0015.9-1.05a3.254 3.254 0 001.67.44 3.3 3.3 0 001.679-.44 3.157 3.157 0 001.211-1.275 4.054 4.054 0 00.449-1.949z"
          transform="translate(-59.561 11.781)"
        ></path>
      </g>
    </svg>
  );
}
